define([
    "./transitionFailureReasonModule"
], function (module) {
    "use strict";

    return module.constant("FailureType", {
        FOR_WEIGHT: "br.com.neolog.monitoring.monitorable.model.api.FailureType.FOR_WEIGHT",
        FOR_VOLUME: "br.com.neolog.monitoring.monitorable.model.api.FailureType.FOR_VOLUME",
        FOR_QUANTITY: "br.com.neolog.monitoring.monitorable.model.api.FailureType.FOR_QUANTITY",
    });
});